<section class="card border mb-3">
  <form [formGroup]="form" (ngSubmit)="onFormSubmit()" #formRef="ngForm">
    <div class="card-header">
      <h3 class="card-title">
        {{ 'competitionModule.whiteListExplanationText' | translate }}
      </h3>
    </div>
    <div class="card-body">
      <div class="input-group mb-3">
        <!-- <div
          class="btn btn-soft-primary rounded"
          [ngClass]="{ active: !manualDateInput }"
        >
          <input
            class="form-check-input invisible"
            type="radio"
            value="wholeCompetition"
            formControlName="dateOption"
            (change)="onInputChange($event.currentTarget.value)"
            id="wholeCompetition"
          />
          <label class="form-check-label" for="wholeCompetition">{{
            'competitionModule.wholeCompetition' | translate
          }}</label>
        </div> -->

        <div
          class="btn btn-soft-primary"
          [ngClass]="{ active: manualDateInput }"
          hidden
        >
          <input
            aria-labelledby="dateOptionId"
            aria-describedby="dateOption"
            class="form-check-input invisible"
            type="radio"
            value="dateRange"
            formControlName="dateOption"
            (change)="onInputChange($event.currentTarget.value)"
            id="dateRange"
            [attr.aria-invalid]="
              form.controls.dateOption.dirty && form.controls.dateOption.invalid
                ? 'true'
                : null
            "
          />
          <label id="dateOptionId" class="form-check-label" for="dateRange">{{
            'competitionModule.specificDateRange' | translate
          }}</label>
        </div>
        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="dateOption"
          role="alert"
          *ngIf="
            form.controls.dateOption.dirty && form.controls.dateOption.invalid
          "
        >
          {{ 'general.value' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <fieldset class="mb-4" *ngIf="!manualDateInput">
        <legend class="form-label">
          {{ 'competitionModule.selectDays' | translate }}
        </legend>

        <ng-container
          *ngFor="let day of dayOptions$ | async; let i = index"
          formArrayName="days"
        >
          <div class="form-check" *ngIf="day.length">
            <input
              [attr.aria-labelledby]="'id-object-' + i"
              aria-describedby="competitionModuleError"
              type="checkbox"
              [value]="i + 1"
              [formControlName]="i"
              class="form-check-input"
              [id]="'object-' + i"
              (change)="changeSelectedWhiteListOption(i, $event)"
              [attr.aria-invalid]="
                form.controls.days.dirty && form.controls.days.invalid
                  ? 'true'
                  : null
              "
            />
            <label
              [id]="'id-object-' + i"
              class="form-check-label"
              [for]="'object-' + i"
            >
              {{ 'competitionModule.day' + i | translate }}
              {{ day[0] | roundedDate: '5' : true }} -
              {{ day[day.length - 1] | roundedDate: '5' : true }}</label
            >
          </div>
        </ng-container>
        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="competitionModuleError"
          role="alert"
          *ngIf="form.controls.days.dirty && form.controls.days.invalid"
        >
          {{ 'general.value' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </fieldset>

      <div class="row g-2" *ngIf="manualDateInput">
        <fieldset class="col-md-6">
          <legend class="form-label">
            {{ 'general.startDate' | translate }}
          </legend>

          <datetime-input
            formControlName="startDate"
            (ngModelChange)="dateChangeWhiteList($event, 'startDate')"
            [attr.aria-invalid]="
              form.controls.startDate.dirty && form.controls.startDate.invalid
                ? 'true'
                : null
            "
          ></datetime-input>
        </fieldset>

        <fieldset class="col-md-6">
          <legend class="form-label">
            {{ 'general.endDate' | translate }}
          </legend>

          <datetime-input
            formControlName="endDate"
            (ngModelChange)="dateChangeWhiteList($event, 'endDate')"
            [attr.aria-invalid]="
              form.controls.endDate.dirty && form.controls.endDate.invalid
                ? 'true'
                : null
            "
          ></datetime-input>
        </fieldset>
      </div>

      <div class="d-flex py-3">
        <button class="btn btn-primary" type="submit" [disabled]="!form.dirty">
          {{ 'general.add' | translate }}
        </button>
      </div>
      <div
        *ngIf="
          (competitionEntities$ | async)[(team$ | async)?.competitionId]
            ?.minWhitelist > 0
        "
        class="fw-bold"
        [ngClass]="{
          'text-danger':
            (this.selectedWhiteListDays$ | async)?.length <
            (competitionEntities$ | async)[(team$ | async)?.competitionId]
              ?.minWhitelist
        }"
      >
        {{ 'general.youHaveUsed' | translate }}
        {{ (this.selectedWhiteListDays$ | async)?.length }}
        {{ 'general.ofTheMinimum' | translate }}
        {{
          (competitionEntities$ | async)[(team$ | async)?.competitionId]
            ?.minWhitelist
        }}
        {{ 'general.options' | translate }}
      </div>

      <div
        class="table-responsive mt-3"
        *ngIf="(selectedWhiteListDays$ | async)?.length"
      >
        <table class="table table-borderless table-nowrap table-sm">
          <tbody>
            <tr *ngFor="let whitelistDay of selectedWhiteListDays$ | async">
              <td colspan="10">
                <strong>
                  {{
                    whitelistDay.weekday == null
                      ? ('general.daily' | translate)
                      : ('competitionModule.day' + whitelistDay.weekday
                        | translate)
                  }}
                </strong>
              </td>
              <td>
                <span
                  *ngIf="
                    whitelistDay.startDate ==
                      (competitionEntities$ | async)[
                        (team$ | async)?.competitionId
                      ]?.startDate &&
                      whitelistDay.endDate ==
                        (competitionEntities$ | async)[
                          (team$ | async)?.competitionId
                        ]?.endDate;
                    else dateRange
                  "
                >
                  {{ 'competitionModule.wholeCompetition' | translate }}</span
                >
                <ng-template #dateRange>
                  {{
                    whitelistDay.startDate | formatDate: 'd MMM y HH:mm' | async
                  }}
                  -
                  {{
                    whitelistDay.endDate | formatDate: 'd MMM y HH:mm' | async
                  }}
                </ng-template>
              </td>
              <td>
                <button
                  (click)="onClickRemove(whitelistDay)"
                  class="btn btn-soft-primary btn-sm"
                  type="button"
                >
                  {{ 'general.remove' | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- End Row -->
  </form>
</section>
